import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {deleteTicketLinkMutation, DeleteTicketLinkInput} from './__generated__/deleteTicketLinkMutation.graphql';

const mutation = graphql`
	mutation deleteTicketLinkMutation($input: DeleteTicketLinkInput!) {
		deleteTicketLink(input: $input) {
			clientMutationId
			deletedTicketLinkId
		}
	}
`;

function commit(
	environment: Environment,
	input: DeleteTicketLinkInput,
	onCompleted?: (r: deleteTicketLinkMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<deleteTicketLinkMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'deleteTicketLinkMutation'};
